export default __webpack_public_path__ + "static/media/baptism2.390fae8f.jpg";